var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"App"}},[_c('router-view'),_c('pre-loading',{directives:[{name:"show",rawName:"v-show",value:(this.$store.state.preloader),expression:"this.$store.state.preloader"}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }